import {FocusMonitor} from '@angular/cdk/a11y';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Component, ElementRef, Input, OnDestroy, Optional, Self} from '@angular/core';
import {FormBuilder, FormGroup, ControlValueAccessor, NgControl} from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';
import {Subject} from 'rxjs';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UserService } from '../../shared/services/user.service';
import {FormControl} from '@angular/forms';
import {debounceTime, switchMap, tap} from 'rxjs/operators';
import { User } from '../../shared/models/user';
/** Custom `MatFormFieldControl` for telephone number input. */
@Component({
  selector: 'app-user-input',
  templateUrl: 'user-input.component.html',
  styleUrls: ['user-input.component.scss'],
   providers: [        
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UserInputComponent,
            multi: true,
        }
    ]  

})
export class UserInputComponent implements ControlValueAccessor {

	@Input() placeholder: string;
	@Input() errors: string;

	stateCtrl = new FormControl();
	users: User[] = [];

	constructor(
      private userService: UserService
	) { 
  	}
 
  	propagateChange = (_: any) => {};
  	
  	ngOnInit() {      
  		this.userService.getAll('name',2,{},0,20).subscribe(t => this.users = ([new User].concat(t.body)));  
  	}
 
  	onChange(event) {
  		this.propagateChange(this.users.filter(u => u.id === event.value)[0]);
  	}

    writeValue(obj: any): void {      
    	this.stateCtrl.patchValue(obj ? obj.id : null);    
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void { }

    setDisabledState?(isDisabled: boolean): void { }
}